<template>
    <ion-app>
        <ion-content>
            <b-container style="margin-top: 60px;">
                <b-row padding>
                    <b-col>
                        <img
                            alt="Logo"
                            class="m-3"
                            style="margin: 0 auto; max-width: 250px;"
                            src="@/assets/img/Logo-Fachverband_Fliesen_und_Naturstein.jpg"
                        />
                    </b-col>
                </b-row>
                <b-row class="d-flex justify-content-center">
                    <el-card class="login-card">
                        <b-row class="mb-3">
                            <b-col sm="12">
                                <el-input v-model="user.username" placeholder="Benutzername">
                                    <i slot="prefix" class="el-input__icon el-icon-user"></i>
                                </el-input>
                            </b-col>
                        </b-row>
                        <b-row class="mb-3">
                            <b-col sm="12">
                                <el-input v-model="user.password" placeholder="Password" show-password>
                                    <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                                </el-input>
                            </b-col>
                        </b-row>
                        <b-row class="mb-3">
                            <b-col sm="12">
                                <el-button
                                    class="login-button"
                                    type="primary"
                                    :disabled="loginButtonEnabled"
                                    round
                                    @click="doLogin"
                                    >Einloggen</el-button
                                ><br /><br />
                                <span style="font-size: 13px;" class="gray-link"
                                    ><a class="gray-link" href="#">Impressum</a> |
                                    <a class="gray-link" href="#">Datenschutz</a></span
                                >
                            </b-col>
                        </b-row>
                    </el-card>
                </b-row>
            </b-container>
        </ion-content>
    </ion-app>
</template>

<script>
import { ParseErrorHandler } from '@/mixins/ParseErrorHandlerMixin';

export default {
    name: 'LoginView',
    components: {},
    mixins: [ParseErrorHandler],
    data() {
        return {
            user: {
                username: '',
                password: '',
            },
        };
    },
    computed: {
        loginButtonEnabled() {
            return !(this.user.username && this.user.password);
        },
    },
    mounted() {},
    methods: {
        doLogin() {
            this.$parse.User.logIn(this.user.username, this.user.password)
                .then(user => {
                    if (user) {
                        this.$userEventBus.$emit('loggedIn', user);
                    }
                })
                .catch(this.handleError);
        },
    },
};
</script>
